angular
	.module 'App.Module.Vouchers', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY, SEARCH_CONFIGURATION) ->
		$stateProvider
			.state 'vouchers',
				url: '/vouchers',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@vouchers':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'VoucherSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Vouchers'
					searchParams:
						advanced:
							configuration: SEARCH_CONFIGURATION.voucher
						repositoryName: 'VoucherRepository'
						attribute: 'id'
						title: 'general.vouchers'
						itemTemplate: '@app/voucher/voucher.search-result.view.html'
						createEnabled: false

			.state 'vouchers_unsubscribe',
				url: '/vouchers/cards/:id/unsubscribe?token'
				data:
					require_login: false
					hideMenu: true
					hideSubMenu: true
					showFooter: false
				views:
					main:
						templateUrl: '@app/voucher/voucher.unsubscribe.view.html'
						controller: 'VoucherUnsubscribeController'
						controllerAs: 'vm'

			.state 'vouchers.cards',
				url: '/cards/:id'
				abstract: true
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					voucher: (VoucherRepository, $stateParams) ->
						if _.isEmpty($stateParams.id)
							return null
						return VoucherRepository
							.findVoucher $stateParams.id
							.then (response) =>
								return response.data
							.catch =>
								return null
					transactions: (VoucherRepository, $stateParams) ->
						if _.isEmpty($stateParams.id)
							return null

						return VoucherRepository.listTransactions($stateParams.id)

			.state 'vouchers.cards.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'VoucherController'
						controllerAs: 'vm'
						templateUrl: '@app/voucher/voucher.view.html'
